// Moves browser storage written under the app's former name to the `bips.` prefix, so a session,
// draft or in-flight transaction from before the rename is not lost. Imported first in main.tsx,
// so it runs before any module reads storage.
const LEGACY_PREFIX = "v4ult.";
const PREFIX = "bips.";

try {
  const legacy: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k?.startsWith(LEGACY_PREFIX)) legacy.push(k);
  }
  for (const k of legacy) {
    const next = PREFIX + k.slice(LEGACY_PREFIX.length);
    const value = localStorage.getItem(k);
    if (value !== null && localStorage.getItem(next) === null) localStorage.setItem(next, value);
    localStorage.removeItem(k);
  }
} catch {
  // Storage unavailable (private mode, blocked): nothing to migrate.
}
